// extracted by mini-css-extract-plugin
export default {"root":"LegendLabel_root__OU+++","percentage":"LegendLabel_percentage__BACZ2"};